"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (methods, context) {
  methods.forEach(function (method) {
    // eslint-disable-next-line no-param-reassign
    context[method] = context[method].bind(context);
  });
};